'use strict';

const SHELL_COOKIE_NAME = 'shell_page_deal';

const SHELL_FINCH_EXPERIMENT = {
  experimentName: 'shell_finch_deal',
  variantName: 'Treatment',
};

const SHELL_GUARD_EXPERIMENT = {
  experimentName: 'shell_exp_deal',
  variantName: 'Treatment',
};

module.exports = {
  SHELL_COOKIE_NAME,
  SHELL_FINCH_EXPERIMENT,
  SHELL_GUARD_EXPERIMENT,
};
